<template>
  <div
    class="h-slideBar"
    style="padding-top: 0;"
  >
    <div
      class="h-photoInfo"
      v-show="false"
    >
      <i class="h-photoImg">
        <img src="../assets/images/h-photo-icon.png">
      </i>
      <div class="h-photoMan">
        <p>王振刚</p>
        <div class="h-selectRole">
          <el-select v-model="value">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <el-scrollbar
      wrap-class="scrollbar-wrapper"
      ref="scrollbar"
    >
      <div>
        <el-menu
          unique-opened
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          router
          @open="handleOpen"
          @select="handleSelect"
          @close="handleClose"
          background-color="#ffffff"
          text-color="#37383b"
          active-text-color="#0056a4"
        >
          <el-menu-item
            index="/"
            :class="{'is-active':ccc=='/'&&currentMenu == undefined}"
          >
            <i class="h-menu-icon h-menu-icon22"></i>
            <span slot="title">今日待办</span>
          </el-menu-item>
          <el-menu-item
            v-auth="'gzt_xiaoshoujingli'"
            index="/firstPage"
          >
            <i class="h-menu-icon h-menu-icon1"></i>
            <span slot="title">工作台</span>
          </el-menu-item>
          <el-menu-item
            v-auth="'gzt_xiaoweizhu'"
            index="/secondPage"
          >
            <i class="h-menu-icon h-menu-icon1"></i>
            <span slot="title">工作台</span>
          </el-menu-item>
          <el-menu-item
            v-auth="'gzt_caiwurenyuan'"
            index="/thirdPage"
          >
            <i class="h-menu-icon h-menu-icon1"></i>
            <span slot="title">工作台</span>
          </el-menu-item>
          <el-menu-item
            v-auth="'gzt_dailishang'"
            index="/fourthPage"
          >
            <i class="h-menu-icon h-menu-icon1"></i>
            <span slot="title">工作台</span>
          </el-menu-item>
          <el-menu-item
            v-auth="'gzt_dailishang'"
            index="/dashboard"
          >
            <i class="h-menu-icon h-menu-icon1"></i>
            <span slot="title">工作台</span>
          </el-menu-item>
          <el-menu-item index="/personal/dealCenter">
            <i class="h-menu-icon h-menu-icon20"></i>
            <span slot="title">待办中心</span>
          </el-menu-item>
          <el-menu-item index="/personal/messageCenter">
            <i
              class="w-menu-icon h-menu-icon h-menu-icon21"
              style="width: 0.22rem;"
            ></i>
            <span slot="title">消息中心</span>
          </el-menu-item>
          <el-submenu
            v-for="(obj,index) in menuList"
            :key="index"
            :index="obj.id"
            v-if="obj.showflag==1"
          >
            <template slot="title">
              <i :class="obj.ext"></i>
              <span>{{obj.name}}</span>
            </template>
            <!--                        <el-menu-item-group>-->
            <!--                            <el-menu-item v-for="(v2,k2) in obj.children" :key="k2" :index="v2.url">{{v2.name}}</el-menu-item>-->
            <!--                        </el-menu-item-group>-->
            <div v-for="(v2,k2) in obj.children">
              <el-menu-item
                :id="v2.id"
                :index="v2.url"
                v-if="v2.children.length==0 || v2.children[0].showflag==0"
              >
                {{v2.name}}
              </el-menu-item>
              <el-submenu
                :id="v2.id"
                :index="v2.url"
                v-else="v2.children.length==0 || v2.children[0].showflag==0"
              >
                <template slot="title"><span style="color: #37383B">{{v2.name}}</span></template>
                <el-menu-item
                  v-for="(v3,k3) in v2.children"
                  :index="v3.url"
                >{{v3.name}}</el-menu-item>
              </el-submenu>
            </div>
          </el-submenu>

        </el-menu>

      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { debounce } from 'loadsh'
export default {
  name: 'leftMenu',
  data () {
    return {
      value: {},
      options: [],
      currentMenu: '/',
      currentOpen: [],
      ccc: '/',
      scrollTop: 0,
    }
  },
  computed: {
    menuList: {
      get () {
        return this.$store.state.menus
      }
    }
  },
  created () {
    this.getUrl();
    // this.getOpen();
  },
  mounted () {
    this.getOpen();
    this.initScrollBar();
  },
  methods: {
    // 监听scrollbar滚动事件
    initScrollBar () {
      let scrollbarEl = this.$refs.scrollbar.wrap
      let scrollTop = window.localStorage.getItem('leftMenuScrollTop')
      if (scrollTop) {
        this.scrollTop = scrollTop;
        setTimeout(() => {
          scrollbarEl.scrollTop = this.scrollTop;
        }, 400)
      }
      scrollbarEl.onscroll = debounce((event) => {
        window.localStorage.setItem('leftMenuScrollTop', scrollbarEl.scrollTop)
      }, 200)
    },
    //展开
    handleOpen (key, keyPath) {
      let crr = JSON.stringify(keyPath);
      sessionStorage.currentOpen = crr;
    },
    handleSelect (key, keyPath) {
      console.log(key, keyPath, "selectHandle");
      this.ccc = key;
      sessionStorage.currentIndex = key;;
    },
    // 获取展开
    getOpen () {
      try {
        let getCrr = JSON.parse(sessionStorage.currentOpen);
        console.log(getCrr, "huo获取到的数组");
        this.currentOpen = getCrr;
      } catch (e) {

      }
    },
    //合并
    handleClose (key, keyPath) {
      console.log(key, keyPath);
    },
    getUrl () {
      let self = this;
      // let currentUrl = window.location.href;
      // self.currentMenu = currentUrl.split('#')[1];
      self.currentMenu = sessionStorage.currentIndex;
      console.log(self.currentMenu)
    }
  },
  // computed:{
  // 	currentMenu(){
  // 		return this.$route.path.replace('/','');
  // 	}
  // }
}
</script>

<style>
.h-slideBar .w-menu-icon {
  background-size: 0.2rem !important;
}
/*wgy菜单关闭*/
.el-submenu.el-submenu > .el-submenu__title .el-submenu__icon-arrow {
  -webkit-transform: rotateZ(0deg);
  -ms-transform: rotate(0deg);
  transform: rotateZ(0deg);
}
/*wgy菜单展开*/
.el-submenu.el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
  -webkit-transform: rotateZ(180deg);
  -ms-transform: rotate(180deg);
  transform: rotateZ(180deg);
}
</style>
